import { useRegisterFeedbackContext } from "@appretio/feedback";
import { useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Stamps route-level facts into every feedback report: `page_loaded_at` is
 * the ISO-8601 UTC instant the current route (pathname) was entered —
 * re-stamped on navigation, not read at submit time. Rendered once inside
 * the FeedbackProvider, next to the modal, so it covers every page.
 */
export function RouteFeedbackContext() {
  const { pathname } = useLocation();
  // Stamped during render (not an effect) so a submit in the same tick as a
  // navigation still reads the fresh value; the ref survives re-renders that
  // don't change the pathname.
  const pageLoadedAtRef = useRef(new Date().toISOString());
  const previousPathnameRef = useRef(pathname);
  if (previousPathnameRef.current !== pathname) {
    previousPathnameRef.current = pathname;
    pageLoadedAtRef.current = new Date().toISOString();
  }

  useRegisterFeedbackContext(() => ({
    page_loaded_at: pageLoadedAtRef.current
  }));

  return null;
}
